import { useId, useState } from 'react'
import { Stack } from '@mui/material'
import { AppearanceBrightnessSection } from '@/components/Settings/AppearanceBrightnessSection'
import { AppearanceDockSection } from '@/components/Settings/AppearanceDockSection'
import { AppearanceModeSection } from '@/components/Settings/AppearanceModeSection'
import { AppearanceThemeSection } from '@/components/Settings/AppearanceThemeSection'
import { settingsRowPaperClassName } from '@/components/Settings/settingsPaperGroup'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function AppearanceSettingsContent() {
  const [appearanceMode, setAppearanceMode] = useState('light')
  const [brightness, setBrightness] = useState(72)
  const [accentColor, setAccentColor] = useState('blue')
  const [textHighlight, setTextHighlight] = useState('automatic')
  const [dockSize, setDockSize] = useState(28)
  const [dockMagnification, setDockMagnification] = useState(42)

  const paperSingle = settingsRowPaperClassName({ groupPosition: 'single' })
  const paperFirst = settingsRowPaperClassName({ groupPosition: 'first' })
  const paperLast = settingsRowPaperClassName({ groupPosition: 'last' })
  const appearanceHeadingId = useId()
  const brightnessHeadingId = useId()
  const themeHeadingId = useId()
  const dockHeadingId = useId()

  return (
    <Stack spacing={2.5} className={shared.briefingsRoot}>
      <AppearanceModeSection headingId={appearanceHeadingId} paperSingle={paperSingle} appearanceMode={appearanceMode} onAppearanceModeChange={setAppearanceMode} />
      <AppearanceBrightnessSection headingId={brightnessHeadingId} paperSingle={paperSingle} brightness={brightness} onBrightnessChange={setBrightness} />
      <AppearanceThemeSection headingId={themeHeadingId} paperFirst={paperFirst} paperLast={paperLast} accentColor={accentColor} onAccentColorChange={setAccentColor} textHighlight={textHighlight} onTextHighlightChange={setTextHighlight} />
      <AppearanceDockSection headingId={dockHeadingId} paperSingle={paperSingle} dockSize={dockSize} onDockSizeChange={setDockSize} dockMagnification={dockMagnification} onDockMagnificationChange={setDockMagnification} />
    </Stack>
  )
}
